type OssResizeOptions = {
  /** 宽度 */
  w?: number;
  /** 高度 */
  h?: number;
  /** 百分比缩放，如 50 表示 50% */
  p?: number;
  /** 缩放模式 lfit/mfit/fill/pad/fixed */
  m?: 'lfit' | 'mfit' | 'fill' | 'pad' | 'fixed';
  /** 是否允许放大（等于 limit=0） */
  limit0?: boolean;
  /** 指定长边长度 */
  l?: number;
  /** 指定短边长度 */
  s?: number;
  /** pad 模式填充颜色，如 'FFFFFF' */
  color?: string;
};

/**
 * 构建阿里云 OSS 图片缩放处理 URL
 * @param originalUrl 原始 OSS 图片 URL
 * @param opt 缩放参数
 */
export const buildImageOssResize = (
  originalUrl: string,
  opt: OssResizeOptions
): string => {
  if (!originalUrl) return
  const params: string[] = [];

  // 等比缩放优先
  if (typeof opt.p === 'number') {
    params.push(`p_${opt.p}`);
  } else {
    if (typeof opt.w === 'number') params.push(`w_${opt.w}`);
    if (typeof opt.h === 'number') params.push(`h_${opt.h}`);
    if (typeof opt.l === 'number') params.push(`l_${opt.l}`);
    if (typeof opt.s === 'number') params.push(`s_${opt.s}`);
    if (opt.m) params.push(`m_${opt.m}`);
    if (opt.color) params.push(`color_${opt.color}`);
  }

  if (opt.limit0) {
    params.push(`limit_0`);
  }

  if (params.length === 0) {
    return originalUrl;
  }

  const query = params.join(',');
  return `${originalUrl}?x-oss-process=image/resize,${query}`;
};
